<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-modal no-close-on-backdrop id="create" hide-footer>
      <template v-slot:modal-title>CADASTRAR TIPO DE COBRANÇA</template>
      <Create @success="paginate" />
    </b-modal>
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              TIPOS DE COBRANÇAS DE SERVIÇOS
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'service_charge_type')"
              class="btn-add"
              v-on:click="handleModalCreate"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-7 col-sm-8 col-12 pt-0 pb-1">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Pesquisar tipos de cobrança de serviços"
              outlined
              dense
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="data.length > 0"
          v-if="permission('read', 'service_charge_type')"
          dense
          :headers="headers"
          :items="data"
          :search="search"
          sort-by="name"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'MOSTRAR',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.name`]="{ item }">
            {{ item.name }}
            <b-modal
              no-close-on-backdrop
              :id="`edit_${String(item.id)}`"
              hide-footer
            >
              <template v-slot:modal-title>EDITAR TIPO DE COBRANÇA</template>
              <Edit @success="paginate" :item="item" />
            </b-modal>
          </template>
        </v-data-table>
        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";

import Create from "../templates/ServicesChargeTypes/create";
import Edit from "../templates/ServicesChargeTypes/edit";

import api from "../services/api";

import permission from "../lib/permission";

import { formatDate } from "../lib/format";

import routes from "../routes";

export default {
  name: "ServicesChargeTypes",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    Create,
    Edit,
  },
  data() {
    return {
      search: "",
      headers: [{ text: "NOME", value: "name" }],
      data: [],
      id: "",
      loading: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatDate,

    handleToBack: () => routes.go(-1),

    handleModalCreate() {
      this.$bvModal.show("create");
    },

    handleClickRowTable(item) {
      this.id = item.id;
      this.$bvModal.show(`edit_${String(item.id)}`);
    },

    async retrieve() {
      await this.paginate();
    },

    async paginate(page = 1) {
      try {
        this.loading = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get(
          "/rest-home/service-charge-type/paginate",
          {
            params,
          }
        );

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = types;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
